import { Navigate, Outlet, useLocation } from 'react-router';
import { useAppSelector } from '@/app/hooks';
import { selectIsAuthenticated, selectSessionEndReason } from '@/shared/session';
import { buildLoginUrl } from '../model/returnTo';

/**
 * Layout route guard for authenticated areas. Reacts to the store, so sign-out, token expiry
 * and 401 responses all redirect to sign-in immediately.
 */
export function RequireAuth() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const endReason = useAppSelector(selectSessionEndReason);
  const location = useLocation();

  if (!isAuthenticated) {
    // After a deliberate sign-out, don't send the next user back to the previous user's page.
    const returnTo =
      endReason === 'signedOut' ? undefined : location.pathname + location.search + location.hash;
    return <Navigate to={buildLoginUrl(returnTo)} replace />;
  }

  return <Outlet />;
}
